import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import FlexBox, { FlexGrow } from "./FlexBox";
import Icon from "./Icon";
import RecommendedRoadmapDetail from "./RecommendedRoadmapDetail";
import { PersonalizedFit } from "./StyledEvent";
import { StyledText } from "./Text";
import CompetencyAddModalNew from "./CompetencyAddModalNew";

type MultiEventProps = {
  eventData: {
    curriculum_version: number;
    left: string;
    top: string;
    height: string;
    children: Array<any>;
  };
  showPersonalizedFit?: boolean;
};
type EventProps = {
  // title: string;
  // description: string;
  // startDate: string;
  // endDate: string;
  // left: string;
  // top: string;
  height: string;
  backgroundColor: string;
  fontColor: string;
};
type SlideProps = {
  left: string;
  top: string;
  height: string;
};
const SlideContainer = styled.div<SlideProps>`
  margin: 0 auto;
  overflow: hidden;
  border-radius: 8px;
  position: absolute;
  height: auto;
  // width: ${({ height }) => height};
  left: ${({ left }) => left};
  top: ${({ top }) => top};
`;
const Slider = styled.div`
  white-space: nowrap;
  transition: ease 1000ms;
`;
const Slide = styled.div`
  display: inline-block;
  width: 100%;
  height: 100%;
`;
const SlideshowDots = styled.div`
  text-align: center;
`;
const StyledEventBox = styled(FlexBox) <EventProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 12px;
  cursor: pointer;
  height: auto;
  overflow: hidden;
  width: ${({ height }) => height};
  min-width: 230px;
  background: ${({ backgroundColor }) => backgroundColor};
  border-radius: 8px;
  color: ${({ fontColor }) => fontColor};
  i {
    font-style: normal;
    margin-right: 5px;
  }
`;
function MultiEvent({
  eventData,
  showPersonalizedFit = false,
}: MultiEventProps): JSX.Element {
  const [index, setIndex] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedCompetency, setSelectedCompetency] = useState<any>(null);
  const prev = () => {
    setIndex(index - 1);
  };
  const next = () => {
    setIndex(index + 1);
  };
  useEffect(() => {
    setSelected(index);
  }, [index]);
  const setSelected = (ind: any) => {
    eventData.children.forEach((item, i) => (item.selected = ind === i));
  };

  return (
    <React.Fragment>
      {selectedCompetency && (
        <CompetencyAddModalNew
          isWarningOpen={false}
          setIsWarningOpen={() => { }}
          hideAddButton
          isStudent={true}
          isAddModalOpen={isModalOpen}
          setAddModalOpen={setIsModalOpen}
          data={selectedCompetency}
          onAddComplete={() => { }}
          onAddError={() => { }}
        />
      )}
      <SlideContainer
        height={eventData.height}
        top={eventData.top}
        left={eventData.left}
      >
        <Slider
          style={{
            transform: `translate3d(${-index * 100}%, 0, 0)`,
            height: "auto",
          }}
        >
          {eventData.children.map((event, key) => (
            <Slide key={key} style={{ height: "auto", width: "100%" }}>
              <FlexBox
                space={0}
                alignItems="center"
                style={{ gap: "12px", flexWrap: "nowrap" }}
              >
                <StyledEventBox
                  direction="column"
                  height={event.height}
                  fontColor={event.fontColor}
                  backgroundColor={event.backgroundColor}
                  onClick={() => {
                    setSelectedCompetency({
                      ...event,
                      curriculum_version: eventData.curriculum_version,
                    });
                    setIsModalOpen(true);
                  }}
                >
                  <FlexGrow
                    style={{
                      width: "100%",
                      marginBottom: 0,
                    }}
                  >
                    <FlexBox alignItems="flex-start">
                      <FlexGrow
                        style={{
                          flexGrow: 0,
                          whiteSpace: "nowrap",
                          marginRight: "8px",
                        }}
                      >
                        <Icon
                          size={2.625}
                          fixedWidth={false}
                          name="clock-eight"
                        ></Icon>
                        <StyledText>
                          {event.startDate}
                          {" - "}
                          {event.endDate}
                        </StyledText>
                      </FlexGrow>
                      <FlexGrow style={{ flexGrow: 0, whiteSpace: "nowrap" }}>
                        <FlexBox style={{ flexWrap: "nowrap" }}>
                          <FlexGrow style={{ maxHeight: "24px" }}>
                            <Button
                              onClick={(e) => {
                                e.stopPropagation();
                                prev();
                              }}
                              disabled={index === 0}
                              sx={{
                                minWidth: "30px",
                                padding: "2px 0",
                                background:
                                  "linear-gradient(87deg,#8fe64c 24.51%,#7854ca 101.09%)",
                                ":disabled": {
                                  background: "#999",
                                  filter: "opacity(0.5)",
                                },
                              }}
                              variant="contained"
                            >
                              <Icon
                                fixedWidth={false}
                                size={2.5}
                                style={{ margin: 0 }}
                                name="arrow-left"
                                color="rgb(0 0 0)"
                              />
                            </Button>
                          </FlexGrow>
                          <FlexGrow style={{ maxHeight: "24px" }}>
                            <Button
                              onClick={(e) => {
                                e.stopPropagation();
                                next();
                              }}
                              disabled={index === eventData.children.length - 1}
                              sx={{
                                minWidth: "30px",
                                padding: "2px 0",
                                background:
                                  "linear-gradient(267deg,#8fe64c 24.51%,#7854ca 101.09%)",
                                ":disabled": {
                                  background: "#999",
                                  filter: "opacity(0.5)",
                                },
                              }}
                              variant="contained"
                            >
                              <Icon
                                fixedWidth={false}
                                size={2.5}
                                style={{ margin: 0 }}
                                name="arrow-right"
                                color="rgb(0 0 0)"
                              />
                            </Button>
                          </FlexGrow>
                        </FlexBox>
                      </FlexGrow>
                    </FlexBox>
                  </FlexGrow>
                  <FlexGrow style={{ flexGrow: 0, whiteSpace: "nowrap" }}>
                    <StyledText
                      fontWeight="700"
                      style={{ fontSize: "16px", marginRight: "8px" }}
                    >
                      [{event.competency_code}] {event.title}
                    </StyledText>
                    <StyledText
                      color="white"
                      style={{ fontFamily: "Montserrat" }}
                      fontWeight="600"
                    >
                      | Credits: {event.credits}
                    </StyledText>
                  </FlexGrow>
                </StyledEventBox>
                {showPersonalizedFit ? (
                  <PersonalizedFit
                    fitScore={event.fit_score}
                    reason={event.reason}
                  />
                ) : null}
              </FlexBox>
            </Slide>
          ))}
        </Slider>
      </SlideContainer>
    </React.Fragment>
  );
}
export default MultiEvent;
